import { PlusOne,  Visibility, Download, Key } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Card, CardActions, CardContent, Chip, GridLegacy as Grid, IconButton, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormActions, GetStatusIngreso, MotivosIngreso, ObtenerTipoDocumentos, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../../components/form/ModalForm";
import { json, useLocation, useNavigate, useNavigation, useParams } from "react-router-dom";
import { SubtableIngresos } from "../../../components/plataforma/recibo/subtable-ingresos";
import { CustomDialog } from "../../../components/modals/custom-dialog";
import { FormFirma } from "../../../components/plataforma/recibo/form-firma";




const schema = yup.object({

  producto_add: yup.object().shape({
    label:yup.string(),
    value:yup.number()
  }).required(),
  unidad_medida:yup.string().required(),
  bodega:yup.string().required()

}).required();

const schemaIngreso = yup.object({
  producto: yup.mixed().required(),
  unidad_medida:yup.mixed().required(),
  motivo:yup.mixed().required(),
  cantidad_ingreso:yup.number().min(0).required()
}).required();

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const defaultIngreso = {
  producto:"",
  unidad_medida:"",
  cantidad_ingreso:null,
  motivo:null,
  notas:""

}
const producto_ingreso = {
  producto_add:null,
  cod_producto:null,
  unidad_medida:null,
  cod_entrada_compra:null
}

export const DetalleReciboOrden = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...producto_ingreso});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [unidadesMedidas,setUnidadesMedidas] = useState([]);
  const [bodegas,setBodegas] = useState([]);
  const [infoData,setInfoData] = useState({});
  const [customDialogConfig,setCustomDialogConfig] = useState({});
  const [diagConductor,setDiagConductor] = useState({});
  const [datosConductor,setDatosConductor] = useState({numero_documento:"",nombre_conductor:"",firma:""});
  const [modalIngreso,setModalIngreso] = useState({
    isVisble:false,
    data:{}
  });


  let { cod_erp_orden } = useParams();
  const navigate = useNavigate();
 

  useEffect(()=>{


      if (cod_erp_orden){
      
        loadItems();
      }

      

    },[]);
    
    useEffect(()=>{
      if ( Object.keys(infoData).length > 0 && bodegas.length === 0 ){
        loadBodegas(infoData.centro_ope_cod)
      }
    },[infoData]);


    const loadBodegas = (centrop_ope_id)=>{
       AxiosInstance.post("cotzaciones/obtener-bodegas-filter",{
        centrop_ope_id
       }).then(({data})=>{
          setBodegas(data.value);
       });
    }
    

    const onOpenOrCloseVisibleSubItem = (index)=>{
         const cloneData = [...infoData.detalle];
         cloneData[index].isVisble =  !cloneData[index].isVisble;
         setInfoData({
          ...infoData,
          detalle:cloneData
         });
    }

    const loadItems =  async (loading=true)=>{
      
      const baseToData = atob(cod_erp_orden).split("_");
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/consultar-recibo-orden",{
      cod_orden_compra:baseToData[0]
      });
      setInfoData({
        ...value
      });


     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }



    const onShowDetailProduct = (cod_prod)=>{
      setIsVisibleModalDetalle(true);
      let product =  dataSetProdctos.find(prod=>prod.cod === cod_prod);
      product.perfil = product.cod_perfil;
      product.activo = product.ind_estado;
      product.agente_asociado =  product.cod_agente?{value:product.cod_agente,label:product.nombre_agente}:null;
      
      product.productos_asociados =  product.productos_asociados.map(product_aso=>({label:product_aso.descripcion || product_aso.label,value:product_aso.cod || product_aso.value}));
      delete product.clave;
      setProductoSeleccionado(product || {});
      setProductosOptions([...product.productos_asociados]);
      setTipoAction(FormActions.MODIFICAR);
      onOpenModalItem(true);
    
    }

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
          let payload =  {
            ...dataForm,
            cod_producto:dataForm.producto_add.value,
            producto_add:null,
            cod_entrada_compra:infoData.cod_entrada,
        };

     

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post("maestros/registrar-producto-recibo",payload)
        .then(async res=>{
       
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    const onOpenRegProduct = (data_prod)=>{
      
      const unDefault =   data_prod.unidades_medidas.find( option=> String(option.label).includes(String(data_prod.unidad_medida_base).trim()) ); 
      console.log({data_prod,unDefault,unbase:String(data_prod.unidad_medida_base).trim()}); 
      setModalIngreso({
        isVisble:true,
        data:{
          producto:data_prod.nombre_producto,
          cod_producto:data_prod.cod_producto,
          unidad_medida:unDefault.value,
          unidades_medidas:data_prod.unidades_medidas,
          cod_detalle_oc:data_prod.cod_detalle_oc,
          cantidad_ingreso:data_prod.cantidad_ordenada - data_prod.total_um_ingresado,
          motivo:"SIN_NOVEDAD"

        }
      });
    } 
    const onSendRegistroIngreso = (type_mod,payload)=>{
       
        const payloadSend = {
          cod_entrada_compra:infoData.cod_entrada,
          cod_producto:payload.cod_producto,
          cod_unidad_medida:payload.unidad_medida,
          cantidad_entrada:payload.cantidad_ingreso,
          motivo:payload.motivo,
         // notas:infoData.notas,
          cod_detalle_orden_compra:payload.cod_detalle_oc
        };
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post("maestros/agregar-novedad-recibo-orden",payloadSend).then(({data})=>{
          setModalIngreso({
            isVisble:false,
            data:{}
          });
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Guardado",
                message:"Recibo registrado con exito",
                type:DialogType.exitoso,
                isVisible:true
            }
        });
        loadItems();

        }).catch(err=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });

        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });

    } 

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }

    const loadUnidadesMedidas = (info)=>{
        AxiosInstance.get("maestros-marketplace/get-unidades-medidas-prod/"+info.value)
        .then( ({data})=>{
          setUnidadesMedidas(data.value);
        });
    }   


  
    const columnsTable = [
      
     {
      
        key:"nombre_producto",
        keyValue:"nombre_producto",
        label:"Producto",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"calidad_producto",
        keyValue:"calidad_producto",
        label:"Calidad",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
        key:"cantidad_ordenada",
        keyValue:"cantidad_ordenada",
        label:"Cantidad ordenada",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=>`${info.cantidad_ordenada} ${info.unidad_medida_base}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
        },
       {
      
        key:"total_ingresado",
        keyValue:"razon_social",
        label:"Total ingresado UM.C",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Chip color="info" label={`${(info.total_um_ingresado - info.total_um_con_novedad).toFixed(2)} ${info.unidad_medida_base} / ${info.cantidad_ordenada} ${info.unidad_medida_base}`} />,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"total_ingresado",
        keyValue:"razon_social",
        label:"Total ingresado Kg",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Chip color="info" label={`${(info.total_kg_ingresados).toFixed(2)} KG / ${info.total_kg_solicitados} KG`} />,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
  {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({info})=><Button disabled={disabledActionOnConfirm} size="small" onClick={e=>onOpenRegProduct(info)} variant="contained" startIcon={<PlusOne/>} >Ingresar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];
   
    const configModal =  {
      titleModal:"Agregar producto",
      buttomsAction:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[

        
 
        {
          key: "producto_add",
          keyValue: "producto_add",
          label: "Producto a agregar",
          component: AutoCompleteInputWithLabel,
          responsiveSize:7,
          callFuncionOnChange:props=> props?loadUnidadesMedidas(props):{},
          inputProps: {
            size:"small",
            name: 'productos_asociados',
            placeholder:"Escriba el producto a buscar",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searcProductoAsociado,
            options: productosOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key:"unidad_medida",
          keyValue:"unidad_medida",
          label:"Unidad de medida",
          responsiveSize:5,
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:unidadesMedidas
          }
        },
        {
          key:"bodega",
          keyValue:"bodega",
          label:"Bodega",
          responsiveSize:6,
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:bodegas
          }
        },
        
      ]
    }

    const configModalIngreso =  {
      titleModal:"Ingresar producto",
      buttomsAction:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setModalIngreso({isVisble:false,data:defaultIngreso})
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"producto",
          keyValue:"producto",
          label:"Producto",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            disabled:true
          }
        },  
        {
          key:"motivo",
          keyValue:"motivo",
          label:"Motivo",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:Object.keys(MotivosIngreso).map(key=>({label:MotivosIngreso[key],value:key}))
          }
        },
      
        {
          key:"cantidad_ingreso",
          keyValue:"cantidad_ingreso",
          label:"Cantidad a ingresar",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small",
            min:0
          }
        },
         {
          key:"unidad_medida",
          keyValue:"unidad_medida",
          label:"Unidad de medida",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:modalIngreso.data?.unidades_medidas || []
          }
        },
      ],
      arrayInputs:[]
    }
    console.log({datosConductor});


     

    const MakeModalDatosConductor = ()=>{

      let dataLocalConductor = {};
      const Info = {
        isOpened:true,
        title: "Coloque los datos del conductor",
        content:(()=><FormFirma datos_conductor={datosConductor} onChangeData={(key,value)=>{
          dataLocalConductor = {...dataLocalConductor,[key]:value};
        }} />)(),
        actions:[
          {
            title:"ACEPTAR",
            buttomProps:{
              onClick:()=>{
                console.log({dataLocalConductor});
                setDatosConductor({...dataLocalConductor});
                setDiagConductor({});
              },
              variant:"contained",
              size:"small",
              color:"primary"
            }
          }
        ]
      }
      setDiagConductor(Info);


    }

    const onDeleteIngreso = (cod_detalle)=>{

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      AxiosInstance.delete(`maestros/eliminar-ingreso/${cod_detalle}`).then(({data})=>{
          loadItems();
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Ingreso eliminado",
                message:"",
                type:DialogType.exitoso,
                isVisible:true
            }
        });

      }).catch(err=>{

        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Error de comunicacion verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      })
    }

    const reQuiereFirmaConductor = ()=>{
      console.log({infoData,datosConductor});
      const tieneNovedad =  infoData.detalle.some( item=>{
          return  item.total_um_con_novedad > 0; 
       } );
      const tieneFaltantes =  infoData.detalle.some( item=>{
        return  item.total_kg_ingresados != item.total_kg_solicitados;
     } );

     const hasDriverData = Object.keys(datosConductor).every( key=>datosConductor[key] && datosConductor[key].length > 0 );

     console.log({tieneNovedad,tieneFaltantes,hasDriverData,res:(tieneFaltantes || tieneNovedad ) && hasDriverData === false});

     return (tieneFaltantes || tieneNovedad ) && hasDriverData === false;
    }

    const sendConfirmIngreso = ()=>{


      
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
        AxiosInstance.post(`maestros/confirmar-ingreso/${infoData.cod_entrada}`,datosConductor)
        .then(({data})=>{

          if (data.status){
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Proceso exitoso",
                  message:"El Ingreso ha sido enviado con exito",
                  type:DialogType.exitoso,
                  isVisible:true
              }
          });
          }else{
            dispatch({
              type:ActionTypes.setModalInfo,
              data:{
                  title:"Proceso con errores",
                  message:data.msg,
                  type:DialogType.informativo,
                  isVisible:true
              }
          });
          }
  

        }).catch(error=>{

         

        }).finally(()=>{
          loadItems();
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
    }

    const onSendConfirmIngreso = ()=>{

      let errorList = "";
      infoData.detalle.forEach( det_item=>{
        if ( det_item.total_kg_ingresados < det_item.total_kg_solicitados){
            errorList += `Item ${det_item.nombre_producto} no esta ingresado en su totalidad\n`;
        }
      });
      console.log({errorList});
      if ( errorList.length > 0 ){

        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Los items no estan totalmente ingresados",
              message:errorList,
              type:DialogType.exitoso,
              isVisible:true
          }
        });
      return;
      }
     
      const require_Data = reQuiereFirmaConductor();
      console.log({require_Data});
      //return;
      if (require_Data){
        MakeModalDatosConductor();
        return;
      }
      sendConfirmIngreso();
    }

    
    const getColorStatus = (ing_status)=>{
     
      if ( ing_status === 'ANULADO' || ing_status === 'CON_ERROR' ){
        return "error";
      }
      if ( ing_status === 'TRANSMITIDA' ){
        return "success";
      }
      return "default";
    }
    

    const disabledActionOnConfirm = !['BORRADOR','ANULADO'].includes( infoData.ingreso_estado );

    const downloadDocument = (cod,tipo)=>{
      AxiosInstance.get(`maestros/descargar-documento-by-oc/${cod}/${tipo}`)
      .then(({data})=>{
        let element = document.createElement("a");
        element.style.display = 'none';
        element.href = `data:application/pdf;base64,${data.base_64}`;
        element.download =  data.name_pdf;
       // document.body.appendChild(element);
        element.click();
       // document.body.removeChild(element); 
      }).catch(err=>{
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error de consulta documento",
            message: "Se ha presentado un error consultando el documento",
            type: DialogType.informativo,
            isVisible: true
          }
        });
      }).finally(()=>{
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:false
        });
      });

    
    }

    const openedModalLog = (typeInfo,log_imp = '')=>{
      const title =  { 
        EA:"LOG Entrada de almacen",
        ER:"LOG ENTRADA POR RECLASIFICACION",
        NP:"LOG NOTA PROVEEDOR"
      }
      const Info = {
        isOpened:true,
        title: title[typeInfo],
        content:<div dangerouslySetInnerHTML={{__html:log_imp}} ></div>,
        actions:[
          {
            title:"OK",
            buttomProps:{
              onClick:()=>setCustomDialogConfig({}),
              variant:"contained",
              size:"small",
              color:"primary"
            }
          }
        ]
      }
      setCustomDialogConfig(Info);
      
    }

    return (<>

     {
      <CustomDialog
      {...customDialogConfig}
      />
     }

{
      <CustomDialog
      {...diagConductor}
      />
     }

    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }

{
      modalIngreso.isVisble &&
    <ModalFormGenerador 
    isVisible={modalIngreso.isVisble}
    schemaValidator={schemaIngreso}
    entityValues={modalIngreso.data}
    {
      ...configModalIngreso
    }
    onSendForm={onSendRegistroIngreso}
    typeAction={tipoAction}
    />
    }
   
    <Grid container spacing={2} >
    <Grid item sm={12} xs={12} md={10} >
      <Typography variant="h6" >
          Datos de la orden de compra
      </Typography>
    </Grid>
        <Grid item sm={12} xs={12} md={10} >
            <Card>
              <CardContent>
                <Grid container >
                  <Grid item sm={6} xs={6} md={6} >
                      <Typography variant="p" >
                        <strong>Codigo OCM:</strong> {infoData.cod_erp}
                      </Typography>
                  </Grid>
                  <Grid item   sm={6} xs={6} md={6}>
                      <Typography variant="p" >
                        <strong>Proveedor:</strong> {infoData.proveedor}
                      </Typography>
                  </Grid>
                  <Grid item sm={6} xs={6} md={6} >
                      <Typography variant="p" >
                        <strong>COP de recibo:</strong> {infoData.centro_operacion}
                      </Typography>
                  </Grid>
                  <Grid item sm={6} xs={6} md={6} >
                      <Typography variant="p" >
                        <strong>Fecha estimada de recibo:</strong> {dayjs(infoData.fecha_creacion).format(DateFormatString)}
                      </Typography>
                  </Grid>
                  <Grid item sm={6} xs={6} md={6} >
                    <Typography variant="p" >
                        <strong>Comprador:</strong> {infoData.nombre_comprador}
                      </Typography>
                  </Grid>
                  <Grid item sm={6} xs={6} md={6} >
                    <Typography variant="p" >
                        <strong>Estado del recibo:</strong> <Chip color={getColorStatus( infoData.ingreso_estado )} label={infoData.ingreso_estado} />
                      </Typography>
                  </Grid>
                </Grid>
              </CardContent>

            </Card>
        </Grid>
        {
          infoData.documentos_generados?.length > 0 &&   
          
          <Grid container item sm={12} xs={12} md={12} >
              
          <Grid item sm={12} xs={12} md={12} >
            <Typography variant="p" >Documentos generados</Typography>
          </Grid>
          {
            infoData.documentos_generados?.map(item_doc=><Grid key={item_doc.cod} item sm={12} xs={12} md={4} >
              <Card>
            <CardContent>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                {ObtenerTipoDocumentos[item_doc.tipos_documentos]}
              </Typography>
              <Typography variant="h5" component="div">
               {item_doc.cod_erp || 'SIN DOCUMENTO ERP'}
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                <Chip color={getColorStatus(item_doc.ind_estado)} label={ GetStatusIngreso[item_doc.ind_estado]}  />
              </Typography>
            
            </CardContent>
            <CardActions>
              {console.log({item_doc})}
                {
                  item_doc.tipos_documentos === 'NP' && 
               
                  <Button onClick={e=>downloadDocument(item_doc.consecutivo_documento,item_doc.tipos_documentos)} color="primary" size="small" variant="contained" ><Download /></Button>
              
                }
                {
                  item_doc.log_importacion_erp &&
                  <Button onClick={e=>openedModalLog(item_doc.tipos_documentos,item_doc.log_importacion_erp)} size="small" variant="contained" color="primary" >Ver Log</Button>
                }
              </CardActions>
              </Card>
            </Grid>)
          }
          
    </Grid>
        }
      
        <Grid item sm={12} xs={12} md={6} >
          <Typography variant="h6" >
            Listado de productos a ingresar
          </Typography>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >
        <Stack direction={"row"} spacing={1} >
        <Button onClick={e=>navigate(-1)} type="button" variant="contained" size="small" color="error"  >Regresar </Button> 
          <Button disabled={disabledActionOnConfirm} onClick={onSendConfirmIngreso} type="button" variant="contained" size="small" color="primary"  >
            {infoData.ingreso_estado === 'ANULADO'?
            'Reenviar Ingreso':
            'Confirmar Ingreso'
          }
            </Button>
        </Stack>
          
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>
              <TableCell></TableCell>
                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {infoData.detalle?.map( (prod,prod_index)=>
                  [
                    <TableRow key={prod.cod}  >
                      <TableCell>
                        <IconButton  
                        onClick={e=>onOpenOrCloseVisibleSubItem(prod_index)}
                        >
                         <Visibility />
                        </IconButton>  
                      </TableCell>
                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>,
                  <TableRow key={prod.cod+"sec"} >
                   <TableCell colSpan={columnsTable.length+1} >
                       <SubtableIngresos  disabledActionOnConfirm={disabledActionOnConfirm}  onDeleteIngreso={onDeleteIngreso} isVisble={prod.isVisble} sub_items={prod.ingresos_novedades} />
                   </TableCell>
                  </TableRow>
                  ]
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>


        </Grid>
    </Grid>
    </>)

}